var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_1002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2 16.8C21.1096 16.8 22.9409 17.5586 24.2912 18.9089C25.6414 20.2591 26.4 22.0905 26.4 24C26.4 25.9096 25.6414 27.741 24.2912 29.0912C22.9409 30.4415 21.1096 31.2 19.2 31.2C17.2904 31.2 15.4591 30.4415 14.1088 29.0912C12.7586 27.741 12 25.9096 12 24C12 22.0905 12.7586 20.2591 14.1088 18.9089C15.4591 17.5586 17.2904 16.8 19.2 16.8ZM30 18C31.8 18 33 20.6868 33 24C33 27.3132 31.8 30 30 30C28.2 30 27 27.3132 27 24C27 20.6868 28.2 18 30 18ZM34.8 18.6C35.256 18.6 35.6544 19.5924 35.856 21.2952L35.9124 21.8268L35.9352 22.1088L35.9712 22.7016L35.9832 23.0124L35.9976 23.6616L36 24L35.9976 24.3384L35.9832 24.9876L35.9712 25.2996L35.9352 25.8912L35.9112 26.1732L35.8572 26.7048C35.6544 28.4088 35.2572 29.4 34.8 29.4C34.344 29.4 33.9456 28.4076 33.744 26.7048L33.6876 26.1732C33.6793 26.0793 33.6717 25.9853 33.6648 25.8912L33.6288 25.2984C33.6242 25.1949 33.6202 25.0913 33.6168 24.9876L33.6024 24.3384V23.6616L33.6168 23.0124L33.6288 22.7004L33.6648 22.1088L33.6888 21.8268L33.7428 21.2952C33.9456 19.5912 34.3428 18.6 34.8 18.6Z",
    fill: "#A0EE09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_1002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconMedium);
export default __webpack_public_path__ + "static/media/menu-icon-medium.6edfdb9c2f112c5c427756c9476066a5.svg";
export { ForwardRef as ReactComponent };